var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-48 h-72 p-2 m-2 border-2 flex flex-col",attrs:{"id":"playable-card"}})}
var staticRenderFns = []

export { render, staticRenderFns }